var React = require('react');

function Pos (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"30","cy":"30","r":"30","fill":"#FFCC00","key":0}),React.createElement("path",{"d":"M28.1999 37.5528H31.7999M25.1999 18H34.7999C36.1247 18 37.1999 19.0752 37.1999 20.4V39.6C37.1999 40.926 36.1247 42 34.7999 42H25.1999C23.8751 42 22.7999 40.926 22.7999 39.6V20.4C22.7999 19.0752 23.8751 18 25.1999 18Z","stroke":"#121212","strokeWidth":"2","strokeLinecap":"square","key":1})]);
}

Pos.defaultProps = {"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none"};

module.exports = Pos;

Pos.default = Pos;
